import { render, staticRenderFns } from "./NoJournalistLogs.vue?vue&type=template&id=25372dd3&"
import script from "./NoJournalistLogs.vue?vue&type=script&lang=js&"
export * from "./NoJournalistLogs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports